import ReactSelect from 'react-select';
import { createComponent } from '@cloudflare/style-container';

var Option = createComponent(function (_ref) {
  var theme = _ref.theme,
      isSelected = _ref.isSelected,
      isFocused = _ref.isFocused,
      isDisabled = _ref.isDisabled;

  var color = isSelected || isFocused ? theme.colors.gray[1] : theme.colors.gray[4];

  var backgroundColor = theme.colors.white;
  if (isFocused) {
    backgroundColor = theme.colors.gray[8];
  } else if (isSelected) {
    backgroundColor = theme.colors.gray[9];
  }

  return {
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'block',
    padding: '8px 10px',
    opacity: isDisabled ? 0.5 : 1,
    backgroundColor: backgroundColor,
    color: color,
    '& [role="option"]': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
}, ReactSelect.defaultProps.optionComponent);
Option.setDisplayName('Option');

export default Option;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/Option.js
// module id = 1109
// module chunks = 1